// extracted by mini-css-extract-plugin
export var showMoreButtonContainer = "styles-module__showMoreButtonContainer___CV3S1";
export var trail = "styles-module__trail___Rjtxj";